import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class UserSessionService {

  private  baseUrl = environment.baseUrl;
  text: string;
  constructor(private http:HttpClient) { }

  closeSession(session:any){
    return this.http.get(`${this.baseUrl}/api/Login/closeSession?session=${session}`)
            .pipe(
                catchError(this.handleError)
            );
  } 

  cancelThisSession(){
    return this.http.get(`${this.baseUrl}/api/Login/cancelThisSession?session="cancelSession"`)
            .pipe(
                catchError(this.handleError)
            );
  } 

  closeAllSessions(allSessions:any){
    return this.http.post(`${this.baseUrl}/api/Login/closeAllSessions`, allSessions)
            .pipe(
                catchError(this.handleError)
            );
  } 

  loadValidUserSessions(){
    return this.http.get(`${this.baseUrl}/api/Login/loadValidUserSessions`)
            .pipe(
                catchError(this.handleError)
            );
  } 

  private handleError(error:HttpErrorResponse) {
    if(error.error instanceof ErrorEvent) {
      console.error('An error occured', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error}`
      );
    }
    return throwError(error.error);
  }
}